export const PLAN_TYPES = {
  WITHOUT_EHR: "without_ehr",
  WITH_EHR: "with_ehr",
};

export const PRICING = {
  without_ehr: 89.99,
  with_ehr: 129.99,
  seatPerMonth: 15,
  maxSupportingSeats: 2,
};

export const PLAN_OPTIONS = [
  {
    id: PLAN_TYPES.WITHOUT_EHR,
    title: "Monthly — Without EHR",
    description: "Platform access without EHR integration",
    price: PRICING.without_ehr,
  },
  {
    id: PLAN_TYPES.WITH_EHR,
    title: "Monthly — With EHR",
    description: "Platform access with EHR integration",
    price: PRICING.with_ehr,
  },
];
